import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { CustomsData, CustomsAuditData } from "../types/customsdata.type";
import { ENV } from "../../../src/constants/env";
import { getToken } from '../../../src/helpers/authProvider';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.JOB_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  // normalize string arg to object so we can set headers
  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken();
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`);
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401 && token) {
      // Handle token refresh if needed
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  error?: string;
}

export const customsApi = createApi({
  reducerPath: 'customsApi',
  baseQuery: authBaseQuery,
  tagTypes: ['customs'],
  endpoints: (builder) => ({
    getCustomsData: builder.query<CustomsData[], number>({
      query: (id) => ({
        url: `Customs/GetCustomsData/${id}`,
        method: 'GET',
      }),
      providesTags: ['customs'],
    }),
    getCustomsById: builder.query<CustomsAuditData[], number>({
      query: (customsId) => ({
        url: `Customs/GetCustomsById/${customsId}`,
        method: 'GET',
      }),
      providesTags: ['customs'],
    }),
  }),
});

export const {
  useGetCustomsDataQuery,
  useGetCustomsByIdQuery,
} = customsApi;
